import React, { FC, useCallback } from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { DestinationAddressResponseDto } from "types/api/destination_addresses";
import { OpenRightPanel } from "types/common/rightPanel";
import { useFeature } from "../../../branding/useFeature";
import { openRightPanel } from "../../../reduxFolder/reducers/rightPanel";
import { AddButton } from "../../Button";

interface AddAddressButtonProps {
  openRightPanel: OpenRightPanel;
  initialPanelData?: any;
  returnPreviousPanel?: string;
  // Called with an address added through this button (recognized or filled
  // in); the host decides what to do with it: select, save, highlight.
  onAddressAdded?: (address: DestinationAddressResponseDto) => void;
  className?: string;
}

export const AddAddressButton: FC<AddAddressButtonProps> = React.memo(
  ({
    openRightPanel,
    initialPanelData,
    returnPreviousPanel,
    onAddressAdded,
    className = "",
  }) => {
    const { t } = useTranslation("common");
    // Partner flag: free-form entry (parse job) or the static field form.
    const panelType = useFeature("addressParsing")
      ? "ADDRESS_PARSE"
      : "ADDRESS_FORM";
    const handleClick = useCallback(
      () =>
        openRightPanel(
          panelType,
          Map({
            isEditForm: false,
            // Marks the whole panel chain (parse → form) as adding an address,
            // which is what makes leaveWithAddress hand it to the host.
            isNewAddress: true,
            initialPanelData,
            returnPreviousPanel,
            onAddressAdded,
          }),
        ),
      [
        openRightPanel,
        panelType,
        initialPanelData,
        returnPreviousPanel,
        onAddressAdded,
      ],
    );

    return (
      <AddButton onClick={handleClick} className={className}>
        {t("common.addAddress", { word: t("common.another") })}
      </AddButton>
    );
  },
);

const withConnect = connect(null, { openRightPanel });

export default withConnect(AddAddressButton);
